export default "__VITE_ASSET__CZAspDaI__"